export default `
  mutation($id: String!) {
    deleteNoticedReport(id: $id) {
      id
    }
  }
`;